import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from './redux/store'
import { Modal } from 'react-bootstrap'
import { Slide, ToastContainer } from 'react-toastify';

import agentComponent from './biz/agentBiz'
import versionComponent from './biz/versionBiz'
import { updateAgentSlice, logOut } from './redux/features/agentSlice'
import { fetchStates } from './redux/features/stateAreaSlice'
import { fetchPackage } from './redux/features/packageSlice'
import lib from './biz/lib'

const App = () => {
  const agentSlice = useSelector((state: RootState) => state.agent)
  const dispatch = useDispatch<AppDispatch>()
  const [showModal, setShowModal] = useState(false)
  const [isTOOSTRR, setIsTOOSTRR]  = useState(agentSlice.companyName === 'Temporary Out of Service' && agentSlice.active === 'The Roof Realty');

  useEffect(() => { //handle update redux after click refresh
    dispatch(fetchStates())
    dispatch(fetchPackage())
    checkAgentStatus()
  }, [])

  useEffect(() => {
    const onFocus = () => {
      checkAgentStatus()
      checkVersion()
    }
    // Remove the previous event listener if it exists since App.tsx won't unmount
    window.removeEventListener('focus', onFocus);

    // Add the new event listener
    window.addEventListener('focus', onFocus);

    // Clean up by removing the event listener when the component unmounts
    return () => {
      window.removeEventListener('focus', onFocus);
    };
  }, [agentSlice])

  const checkAgentStatus = async () => { //check package info, expiry date, active status
    let changed = false
    if (agentSlice._id) {
      const latestAgent = await agentComponent.searchById(agentSlice._id)
      if (latestAgent) {
        const newPackageInfo = await agentComponent.getPackage(agentSlice._id)
        const newPostingAccess = await agentComponent.getPostingAccess(agentSlice._id)
        const newPropStoryAccess = await agentComponent.getPropStoryAccess(agentSlice._id)
        // let newPayload = {packageInfo: {...agentSlice.packageInfo}, expiryDate: agentSlice.expiryDate}
        let newPayload = {
          postingAccess : agentSlice.postingAccess,
          propStoryAccess : agentSlice.propStoryAccess,
          packageInfo: { ...agentSlice.packageInfo }, expiryDate: agentSlice.expiryDate,
          TOOS: agentSlice.TOOS, active: agentSlice.active,
        }
        if (newPackageInfo._id !== agentSlice.packageInfo._id) {
          newPayload.packageInfo = { ...newPackageInfo }
          changed = true
        }
        if(newPostingAccess !== agentSlice.postingAccess) {
          newPayload.postingAccess = newPostingAccess;
          changed = true;
        }
        if(newPropStoryAccess !== agentSlice.propStoryAccess) {
          newPayload.propStoryAccess = newPropStoryAccess;
          changed = true;
        }
        if (latestAgent.expiryDate !== agentSlice.expiryDate) {
          newPayload.expiryDate = latestAgent.expiryDate
          changed = true
        }
        if (latestAgent.active !== agentSlice.active) {
          newPayload.active = latestAgent.active
          changed = true          
        }
        if (latestAgent.active === 'Temporary Out of Service') {
          newPayload.TOOS = true;
          if (agentSlice.companyName === 'The Roof Realty') {
            setShowModal(true);
            setIsTOOSTRR(true);
            dispatch({ type: 'USER_LOGOUT' })
          }
        } else if (latestAgent.active === 'In Service') {
          newPayload.TOOS = false
        } else if (latestAgent.active === 'Disabled') {
          setShowModal(true)
          dispatch({ type: 'USER_LOGOUT' })
        }
        if (changed) {
          dispatch(updateAgentSlice({ ...agentSlice, ...newPayload }))
        }
      }
    }
  }

  const checkVersion = async () => {
    const devMode = process.env.REACT_APP_DEV_MODE
    const currentVersion = process.env.REACT_APP_VERSION
    const latestVersion = await versionComponent.getCurrentVersion()
    // lib.log(`currentVersion: ${currentVersion} | lastestVersion: ${latestVersion.agent}`)
    if (devMode === "false" && latestVersion.agent !== currentVersion) {
      window.location.reload()
    }
  }

  useEffect(() => {
    const handleStorageChange = (event: any) => {
      if (event.key === 'logoutFlag') {
        dispatch({ type: 'USER_LOGOUT' })
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      // Clean up the event listener when the component is unmounted
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch])

  const logoutAgent = () => {
    setShowModal(false)
    dispatch({ type: 'USER_LOGOUT' })
    //@ts-ignore
    window.location = '/'
  }

  const AutoLogoutModal = () => {
    return (
      <Modal show={showModal} onHide={() => setShowModal(false)} backdrop='static' keyboard={false}>
        <Modal.Body className='modal-body-text'>
          {isTOOSTRR? "This account is temporary out of service." : "Your account had been disabled."} Please contact admin for further assistances.
        </Modal.Body>
        <Modal.Footer className='modal-footer-wrapper'>
          <button className='orange-modal-button' onClick={logoutAgent}>
            OK
          </button>
        </Modal.Footer>
      </Modal>
    )
  }

  return (
    <>
      <Suspense fallback={<LayoutSplashScreen />}>
        <I18nProvider>
          <LayoutProvider>
            <ToastContainer autoClose={2000} draggable={false} transition={Slide} hideProgressBar/>
            <AutoLogoutModal />
            <Outlet />
            <MasterInit />
          </LayoutProvider>
        </I18nProvider>
      </Suspense>
    </>
  )
}

export { App }
